import React, { Fragment, memo } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
export function Footer() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatchTab = (tab: string) => {
    // Persist the desired tab so ColeccionesTabs can pick it up even if it
    // mounts/remounts after navigation (covers coming from another page).
    try {
      window.sessionStorage.setItem('savia:pendingTab', tab);
    } catch {
      // ignore storage errors
    }
    window.dispatchEvent(new CustomEvent('savia:tab', {
      detail: tab
    }));
  };
  const scrollToColecciones = () => {
    const target = document.getElementById('colecciones');
    const nav = document.getElementById('nav');
    if (target) {
      const offset = (nav?.offsetHeight ?? 0) + 24;
      window.scrollTo({
        top: target.getBoundingClientRect().top + window.scrollY - offset,
        behavior: 'smooth'
      });
    }
  };
  // Scroll to the "Más allá / Kits & Objetos" section using the SAME landing
  // point as the top nav "Kits & Objetos" button (nav offset + 120).
  const scrollToMasAlla = () => {
    const target = document.getElementById('mas-alla');
    const nav = document.getElementById('nav');
    if (target) {
      const offset = (nav?.offsetHeight ?? 0) + 24;
      window.scrollTo({
        top: target.getBoundingClientRect().top + window.scrollY - offset + 120,
        behavior: 'smooth'
      });
    }
  };
  const goToMasAlla = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/');
      window.setTimeout(scrollToMasAlla, 200);
      return;
    }
    scrollToMasAlla();
  };
  // Switch the collections tab AND scroll to the collections section on every
  // click, whether we're already on home or arriving from another page.
  const goToColeccion = (e: React.MouseEvent<HTMLAnchorElement>, tab: string) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      // From another page: navigate home, then activate + scroll once mounted.
      dispatchTab(tab);
      navigate('/');
      window.setTimeout(() => {
        dispatchTab(tab);
        scrollToColecciones();
      }, 200);
      return;
    }
    // Already on home: activate the tab and scroll right away.
    dispatchTab(tab);
    // Re-dispatch shortly after in case the section is still settling.
    window.setTimeout(() => dispatchTab(tab), 120);
    scrollToColecciones();
  };
  return <footer className="footer" data-id="element-122" data-mp="1hk5vvpi2qfaa">
      <div className="savia-container" data-id="element-123" data-mp="1hj49wpzis8ds">
        <div className="footer__grid" data-id="element-124" data-mp="1mjsbg5ldk7m9">
          <div data-id="element-125" data-mp="1mktp8htrz87o">
            <Link to="/" className="footer__logo" data-id="element-126" data-mp="1mkbhop1nx7kg">
              SAVIA
            </Link>
            <span className="footer__tagline" data-id="element-127" data-mp="1rhk5b55ky3t3">
              Hecho para habitar en silencio.
            </span>
            <p className="footer__desc" data-id="element-128" data-mp="3ocq1jtnrom3i">
              Velas artesanales de cera de soya 100% vegetal. Hechas a mano en
              Bogotá. Enviamos a toda Colombia con la misma intención con que
              hacemos cada pieza.
            </p>
          </div>
          <div data-id="element-129" data-mp="25o58kfiwzlb3">
            <span className="footer__col-title" data-id="element-130" data-mp="25nlq8xpcquwj">Colecciones</span>
            <ul className="footer__links" data-id="element-131" data-mp="21mjz745l9p5n">
              <li data-id="element-132" data-mp="21nbknm5h26i7">
                <Link to="/#colecciones" onClick={e => goToColeccion(e, 'origen')} data-id="element-133" data-mp="21kpf1s25612m">
                  Origen
                </Link>
              </li>
              <li data-id="element-134" data-mp="2tbvfyapos2sy">
                <Link to="/#colecciones" onClick={e => goToColeccion(e, 'memoria')} data-id="element-135" data-mp="2pcnrwgh8o4hv">
                  Memoria
                </Link>
              </li>
              <li data-id="element-136" data-mp="2fegmmuwbbavp">
                <Link to="/#colecciones" onClick={e => goToColeccion(e, 'pausa')} data-id="element-137" data-mp="2fezz3w37172c">
                  Pausa
                </Link>
              </li>
              <li data-id="element-138" data-mp="13y058w176k67">
                <Link to="/#mas-alla" onClick={goToMasAlla} data-id="element-139" data-mp="13xgo3hjdfzt8">
                  Fragmentos
                </Link>
              </li>
              <li data-id="element-140" data-mp="2rtwkvw8dco95">
                <Link to="/#mas-alla" onClick={goToMasAlla} data-id="element-141" data-mp="2wm7nx7yeoq5x">
                  SAVIA Forma
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-142" data-mp="2isyfpam72aoz">
            <span className="footer__col-title" data-id="element-143" data-mp="2it89l9ad11zy">Información</span>
            <ul className="footer__links" data-id="element-144" data-mp="2nunqcp5i8mcj">
              <li data-id="element-145" data-mp="3bjzyrmt0cqds">
                <Link to="/#nosotros" data-id="element-146" data-mp="3bjgrr14wbmej">Nosotros</Link>
              </li>
              <li data-id="element-147" data-mp="3flbqpyzctnp5">
                <Link to="/pages/envios-devoluciones" data-id="element-148" data-mp="3fltvjk031a8o">
                  Envíos & Devoluciones
                </Link>
              </li>
              <li data-id="element-149" data-mp="31l0zguu4u73g">
                <Link to="/pages/preguntas-frecuentes" data-id="element-150" data-mp="31nn86xsresn9">
                  Preguntas frecuentes
                </Link>
              </li>
              <li data-id="element-151" data-mp="1q5ui3qpfkyn8">
                <Link to="/pages/politica-de-privacidad" data-id="element-152" data-mp="1q5cda5opdc3p">
                  Política de privacidad
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-153" data-mp="1nlpfyikagnlv">
            <span className="footer__col-title" data-id="element-154" data-mp="1nl6a407wxpo7">Contacto</span>
            <ul className="footer__links" data-id="element-155" data-mp="1nnsig22mo97h">
              <li data-id="element-156" data-mp="1iltbki7oiu5s">
                <a href="https://instagram.com/savia.ritualco" target="_blank" rel="noopener noreferrer" data-id="element-157" data-mp="1imcv23cz9qlx">
                  @savia.ritualco
                </a>
              </li>
              <li data-id="element-158" data-mp="13xp3e8696119">
                <a href="https://wa.me/573213396782" target="_blank" rel="noopener noreferrer" data-id="element-159" data-mp="13x6ykn5iyehq">
                  WhatsApp
                </a>
              </li>
              <li data-id="element-160" data-mp="1dpcm9koqu9r4">
                <span className="footer__text-plain" data-id="element-161" data-mp="1dpuu7ekrqcev">saviacolombia.com</span>
              </li>
              <li data-id="element-162" data-mp="18uynr9esbmi8">
                <span className="footer__text-plain" data-id="element-163" data-mp="l7h4y3dhzyre">Bogotá, Colombia</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer__bottom" data-id="element-164" data-mp="g7cmw8wxyvz2">
          <p className="footer__copy" data-id="element-165" data-mp="g6b93wojjvdn">
            © {new Date().getFullYear()} SAVIA · Todos los derechos reservados
          </p>
          <p className="footer__made" data-id="element-166" data-mp="2l9gknr8cv7yu">Hecho en Colombia · Con intención</p>
        </div>
      </div>
    </footer>;
}